module.exports = __webpack_public_path__ + "img/furniture_variant_2x.5372d1c.webp";